import React, { useState } from 'react';
import { FileText, Plus } from 'lucide-react';
import CardBasic from '../../ui/Card.jsx';
import InvoicesTabs from './InvoicesTabs.jsx';
import AbschlagTypeDialog from './AbschlagTypeDialog.jsx';
import { useFeatureFlag } from '../../../hooks/useFeatureFlags';

const InvoicesIndex = () => {
    const standaloneAbschlag = useFeatureFlag('standalone_abschlag');
    const [dialogOpen, setDialogOpen] = useState(false);

    const handleNewInvoiceClick = (e) => {
        if (!standaloneAbschlag) return; // Flag inaktiv → normales Link-Verhalten
        e.preventDefault();
        setDialogOpen(true);
    };

    const handleSelect = ({ type }) => {
        setDialogOpen(false);
        if (type === 'abschlag') {
            window.location.href = 'index.php/invoices/new?abschlag=abschlag';
        } else {
            window.location.href = 'index.php/invoices/new';
        }
    };

    return (
        <div>
            <div className="mb-4">
                <div className="d-flex flex-column flex-sm-row align-items-sm-center justify-content-between gap-3">
                    <div>
                        <h1 className="h2 fw-bold text-dark d-flex align-items-center gap-2 mb-2">
                            <FileText size={32} className="icon-invoices" />
                            Rechnungen
                        </h1>
                        <p className="text-muted mb-0">
                            Verwalten Sie Ihre Rechnungen und Mahnungen
                        </p>
                    </div>
                    <a
                        href="index.php/invoices/new"
                        onClick={handleNewInvoiceClick}
                        className="btn btn-outline-primary d-flex align-items-center gap-2 shadow"
                    >
                        <Plus size={20} />
                        Neue Rechnung
                    </a>
                </div>
            </div>
            <CardBasic>
                <InvoicesTabs />
            </CardBasic>

            {standaloneAbschlag && (
                <AbschlagTypeDialog
                    isOpen={dialogOpen}
                    onClose={() => setDialogOpen(false)}
                    onSelect={handleSelect}
                />
            )}
        </div>
    );
}

export default InvoicesIndex;
